import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card position-absolute top-50 start-50 end-50 PleaseWait" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-body align-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "Images/ajax-loader.gif",
    alt: "The page is loading"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bold ps-1" }, "Loading...")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { computed, ref, watch, PropType } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingSpinner',
  props: {
    showLoading: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3, 512)), [
    [_vShow, _ctx.showLoading]
  ])
}
}

})